// frontend-react/src/pages/VerifyEmail.js

import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api/api';
import LoadingSpinner from '../components/LoadingSpinner';
import './LoginPage.css'; // Χρησιμοποιούμε τα ίδια styles

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // verifying | success | error
    const [message, setMessage] = useState('Verifying your email, please wait...');
    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Invalid or missing verification link.');
            return;
        }

        const verify = async () => {
            try {
                const response = await api.get(`/auth/verify-email?token=${token}`);
                setStatus('success');
                setMessage(response.data.message || 'Verification successful! You can now log in.');
            } catch (err) {
                setStatus('error');
                setMessage(err.response?.data?.detail || 'Verification failed. The link may be expired or invalid.');
            }
        };

        verify();
    }, [token]);

    return (
        <div className="login-page-wrapper">
            <div className="login-container">
                <h1>ALGOSTOCK CAPITAL</h1>
                <h2>Email Verification</h2>
                
                {status === 'verifying' && <LoadingSpinner />}
                
                {status === 'success' && <p className="success-message">{message}</p>}

                {status === 'error' && <p className="error-message">{message}</p>}

                <div className="auth-link" style={{ marginTop: '2rem' }}>
                    <Link to="/login">← Go to Login Page</Link>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;